
import {Vue, Component} from 'vue-property-decorator';

import {userApi, accountApi, classesApi} from '@/api';
import formHelper from '../../../js/classes/classes.helper';
import Empty from '@/components/Empty/index.vue';
import importStudent from '../../../components/classes-import-student.vue';
import New_Student from '../account/new_student.vue';
import Batch_Validity from '../account/batct_validity.vue';

import moment from 'moment';
import {getDomainHandle, isLocal} from '@/js/domainUtils';

@Component({
    components: {
        importStudent,
        Empty,
        New_Student,
        Batch_Validity
    }
})
export default class View_Student extends Vue {
    //===================================data区域begin
    classInfo: any = {};
    uploadHeaders: any = {};
    schoolId: any = '';
    schoolName: any = '';
    classId: any = '';
    className: any = '';
    query: any = {
        condition: ''
    };
    columns: any = formHelper.studentColumns;
    pager: any = {
        default: {
            pagesize: 10,
            pagenum: 1,
            total: 0,
            rows: []
        }
    };

    exportStudentId: any = '';
    exportStudentName: any = '';
    // 批量设置账号有效期
    showBatchValidityVisible: boolean = false;
    selectedStudent: any = [];
    selectedRowKeys: any = [];
    // 新建/编辑学生
    studentType: string = '班级管理-新增';
    editStudent: any = [];
    showNewStudent: boolean = false;
    // 复制账号信息
    studentAddress: string = '';
    copystudent: string = '';
    studentLoading: boolean = false;
    //===================================data区域end
    //===================================computed区域begin
    get rowSelection() {
        return {
            columnWidth: '40px',
            //onChange方法，rowSelection改变时触发
            onChange: (selectedRowKeys: any) => {
                //获取选中行的key元素，和下面selectedRowKeys属性配合使用，表示给rowSelection绑定一个v-model，为this.selectedRowKeys
                this.selectedRowKeys = selectedRowKeys;
                // console.log(this.selectedStudent);
            },
            selectedRowKeys: this.selectedRowKeys,
            onSelect: (record: any, selected: boolean, selectedRows: any) => {
                // console.log(record);
                if (selected) {
                    this.selectedStudent.push(record);
                }

                if (!selected) {
                    for (let i = 0; i < this.selectedStudent.length; i++) {
                        if (record._id == this.selectedStudent[i]._id) {
                            this.selectedStudent.splice(i, 1);
                        }
                    }
                }
                // console.log(this.selectedStudent);
            },
            // 用户手动选择/取消选择所有列的回调
            onSelectAll: (selected: boolean, selectedRows: any, changeRows: any) => {
                if (selected) {
                    selectedRows.forEach((el: any) => {
                        if (!this.selectedStudent.some((e: any) => e._id == el._id)) {
                            this.selectedStudent.push(el);
                        }
                    });
                } else {
                    for (let i = 0; i < changeRows.length; i++) {
                        for (let j = 0; j < this.selectedStudent.length; j++) {
                            if (this.selectedStudent[j]._id == changeRows[i]._id) {
                                this.selectedStudent.splice(j, 1);
                            }
                        }
                    }
                }
                // console.log(this.selectedStudent);
            },
            // 表格默认状态
            getCheckboxProps: (record: any) => ({})
        };
    }
    //===================================computed区域end
    //===================================methods区域begin
    // 保存并继续新增
    newAgain() {
        setTimeout(() => {
            this.showNewStudent = true;
        }, 1000);
    }
    // 刷新学生列表
    refreshStudentList() {
        this.pager.default.pagenum = 1;
        this.selectedRowKeys = [];
        this.selectedStudent = [];
        this.getList();
    }
    searchStudent(value: any) {
        this.getList();
    }
    //获取学校信息
    initOrganization(flag: any) {
        let me = this;
        classesApi.getSchoolById({
            context: this,
            urlParamObj: {
                id: me.schoolId
            },
            success(data: any, parameters: any) {
                let domain = data.data;
                me.schoolName = domain.name;
                domain.validStartTime = moment(domain.validStartTime).format('YYYY/MM/DD');
                domain.expireTime = moment(domain.expireTime).format('YYYY/MM/DD');
                window.localStorage.setItem('schoolInfo', JSON.stringify(domain));
                if (flag == 'refreshStudent') {
                    me.showNewStudent = true;
                }
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }
    //导出班级学生名单
    exportClassStudent() {
        let url = '/api/v1/user/export/class/student' + '?classId=' + this.classId;
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                Authorization: this.uploadHeaders['Authorization']
            })
        })
            .then(res => res.blob())
            .then(data => {
                const blobUrl = window.URL.createObjectURL(data);
                const a = document.createElement('a');
                a.download = this.schoolName + this.className + '学生信息' + '.xlsx';
                a.href = blobUrl;
                a.click();
            });
    }
    importStudent() {
        window.localStorage.setItem('classId', this.classId);
        if (this.$refs.importStudent) {
            (this.$refs.importStudent as any).importStudent();
        }
    }
    // 新增学生
    newStudent() {
        this.editStudent = [];
        this.studentType = '班级管理-新增';
        this.classInfo.classId = this.classInfo._id;
        this.editStudent = this.classInfo;
        this.initOrganization('refreshStudent');
    }
    // 批量设置学生有效期
    handleBatchValidity() {
        if (this.selectedStudent.length == 0) {
            this.$message.error('请先选择学生');
            return;
        }
        this.showBatchValidityVisible = true;
    }
    onSelectChange(selectedRowKeys: any, selectedRows: any) {
        this.exportStudentId = selectedRowKeys;
        this.exportStudentName = selectedRows;
    }
    // 学生列表分页
    paginationChangeStudent(page: number) {
        this.pager.default.pagenum = page;
        this.getList();
    }
    // 学生重置密码
    handleResetStudentPwd(record: any) {
        let me = this;
        me.$confirm({
            title: '提示',
            content: '确定重置密码?',
            centered: true,
            onOk() {
                let postData: any = {
                    userId: record._id,
                    operationType: 'password',
                    username: record.username
                };
                accountApi.userOperation({
                    context: me,
                    data: postData,
                    success(data: any, parameters: any) {
                        me.getList();
                        me.$message.success('密码已重置，默认密码为123456');
                    }
                });
            },
            onCancel() {}
        });
    }
    // 编辑
    handleStudentEdit(record: any) {
        // console.log(record);
        this.editStudent = [];
        this.studentType = '班级管理-编辑';
        let editList = JSON.parse(JSON.stringify(this.classInfo));
        editList.classId = record.classId;
        editList.expireTime = record.expireTime;
        editList.isDefaultExpire = record.isDefaultExpire;
        editList.nickname = record.nickname;
        editList.password = record.password;
        editList.sex = record.sex;
        editList.username = record.username;
        editList.validStartTime = record.validStartTime;
        editList._id = record._id;
        this.editStudent = editList;
        this.initOrganization('refreshStudent');
    }
    // 移出本班
    handleInDeleteStudent(record: any) {
        let me = this;
        me.$confirm({
            title: '提示',
            content: '移出本班将同时取消与该班级及课程的关联，请谨慎操作。',
            centered: true,
            onOk() {
                classesApi.deleteStudentInClass({
                    context: me,
                    id: record._id,
                    success(data: any, parameters: any) {
                        me.$message.success('操作成功！该学生已被移出。');
                        me.getList();
                    },
                    error(error: any, message: any) {
                        me.$message.error('操作失败！该学生正在上课中，暂时无法移出本班。');
                    }
                });
            },
            onCancel() {}
        });
    }
    // 复制学生账号信息
    copyStudentInfoTable(record: any) {
        // console.log(record);
        const domainKey = getDomainHandle('key');
        let host = window.location.href;
        if (isLocal()) {
            this.studentAddress = 'http://localhost:8088';
        } else if (host.includes('dev')) {
            this.studentAddress = `https://${domainKey}-student-web.dev.dm-ai.com/Login`;
        } else if (host.includes('stage')) {
            this.studentAddress = `https://${domainKey}-student-web.stage.dm-ai.com/Login`;
        } else if (host.includes('partner')) {
            this.studentAddress = `https://${domainKey}-student-web.partner.dm-ai.com/Login`;
        }else if (host.includes('pet')) {
            this.studentAddress = `https://${domainKey}-student-web.pet.dm-ai.com/Login`;
        } else {
            this.studentAddress = `https://${domainKey}-student-web.dm-ai.com/Login`;
        }
        this.copystudent = `亲爱的用户:
    欢迎使用【${getDomainHandle('title')}】~\n
    点击链接打开网站
    ${this.studentAddress}\n
    然后，使用下方的“账号”和“密码”登录
    姓名：${record.nickname}
    账号：${record.username}
    密码：${record.password}
    有效期：${record.validStartTime}至${record.expireTime}`;
        this.$copyText(this.copystudent).then(e => {
            this.$message.success('复制成功！已复制该用户信息，粘贴给对应的师生即可。');
            // console.log(e);
        });
    }
    showPwd(record: any) {
        if (record.status == 'active') {
            record.status = 'showpwd';
        } else {
            record.status = 'active';
        }
    }
    getList() {
        let me = this;
        me.studentLoading = true;
        let urlQueryParmas = {
            nickname: me.query.condition,
            classId: me.classId,
            page: me.pager.default.pagenum,
            pagesize: me.pager.default.pagesize,
            role: 'student'
        };
        userApi.getList({
            context: me,
            urlQueryParmas: urlQueryParmas,
            success(data: any) {
                // console.log(data.data.list);
                let dataList = data.data.list;
                if (data.data.total > 0) {
                    me.pager.default.rows = data.data.list;
                    me.pager.default.total = data.data.total;
                    // 将时间戳转换为北京时间
                    for (let i = 0; i < dataList.length; i++) {
                        dataList[i].createdAt = moment(dataList[i].createdAt).format('YYYY/MM/DD HH:mm:ss');
                        dataList[i].validStartTime = moment(dataList[i].validStartTime).format('YYYY/MM/DD');
                        dataList[i].expireTime = moment(dataList[i].expireTime).format('YYYY/MM/DD');
                        if (moment(dataList[i].expireTime).format('YYYY/MM/DD') == moment().format('YYYY/MM/DD')) {
                            dataList[i].pastTime = 0;
                        } else {
                            dataList[i].pastTime = moment(dataList[i].expireTime.replace(/\//g, '-')).diff(moment(), 'day');
                            if (dataList[i].pastTime >= 0) {
                                dataList[i].pastTime += 1;
                            }
                        }
                        if (
                            dataList[i].validStartTime != moment().format('YYYY/MM/DD') &&
                            moment(dataList[i].validStartTime.replace(/\//g, '-')).diff(moment(), 'day') >= 0
                        ) {
                            dataList[i].isInvalid = true;
                        }
                    }
                }
                me.studentLoading = false;
            },
            error(error: any, message: string) {
                me.$message.error(message);
                me.studentLoading = false;
            }
        });
    }
    //===================================methods区域end
    created() {
        if (this.$route.query) {
            this.classId = this.$route.query.classId;
            this.className = this.$route.query.className;
        }
        let state = this.$app.getState();
        this.uploadHeaders['Authorization'] = 'Bearer ' + state.token;
        this.schoolId = state.schoolId;
        this.getList();
        this.initOrganization('foo');
        let data = localStorage.getItem('classInfo');
        if (data) {
            this.classInfo = JSON.parse(data);
        }
        // console.log(this);
    }
    // beforeDestroy() {
    //     localStorage.removeItem('classInfo');
    // }
}
